export const type = {
  SAVE_SATUTORY_REPORT: "SAVE_SATUTORY_REPORT",
  REMOVE_SAVE_SATUTORY_REPORT:"REMOVE_SAVE_SATUTORY_REPORT"
}
